// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Page {
  display: flex;
  flex-flow: column nowrap;
  position: relative;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1), 0 2px 4px -2px rgba(16, 24, 40, 0.06);
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 15px;
  overflow-y: auto;
}
@media (min-width: 768px) and (min-height: 576px) {
  .Page {
    height: calc(100vh - 100px);
  }
}
.Page .PageContent {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.Page .PageRow {
  display: flex;
  flex-flow: row nowrap;
  gap: 1.5em;
}
@media (max-width: 767px) {
  .Page .PageRow {
    flex-flow: column nowrap;
  }
}
.Page .PageRow .PageCol {
  flex: 1;
}
.Page .PageHeader {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.5em;
  padding: 0.5em 1.5em;
  background-color: #ffffff;
}
.Page .PageHeaderLeft,
.Page .PageFooterLeft,
.Page .PageHeaderCenter,
.Page .PageFooterCenter,
.Page .PageHeaderRight,
.Page .PageFooterRight {
  flex: 1;
  display: flex;
  align-items: center;
}
.Page .PageHeaderLeft,
.Page .PageFooterLeft {
  justify-content: flex-start;
}
.Page .PageHeaderCenter,
.Page .PageFooterCenter {
  justify-content: center;
}
.Page .PageHeaderRight,
.Page .PageFooterRight {
  justify-content: flex-end;
}
.Page .PageMain {
  flex: 1;
  display: flex;
  flex-flow: column nowrap;
  gap: 0.5em;
  padding: 1.5em;
}
.Page .PageFooter {
  position: sticky;
  inset: auto 0 0 0;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 1.5em;
  background-color: #ffffff;
  padding: 1.5em;
  border-top: 1px solid #E9EAEB;
  z-index: 1;
}
/*# sourceMappingURL=Page.css.map */`, "",{"version":3,"sources":["webpack://./Page.less","webpack://./wp_components/core/Page/Page.less"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uFAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;ACDJ;ADGI;EAAA;IACI,2BAAA;ECAN;AACF;ADdA;EAiBQ,WAAA;EACA,iBAAA;EACA,cAAA;ACAR;ADnBA;EAuBQ,aAAA;EACA,qBAAA;EACA,UAAA;ACDR;ADGQ;EAAA;IACI,wBAAA;ECAV;AACF;AD7BA;EAgCY,OAAA;ACAZ;ADhCA;EAqCQ,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;ACFR;ADOQ;;;;;;EAGI,OAAA;EACA,aAAA;EACA,mBAAA;ACFZ;ADKQ;;EACI,2BAAA;ACFZ;ADKQ;;EACI,uBAAA;ACFZ;ADKQ;;EACI,yBAAA;ACFZ;AD/DA;EAsEQ,OAAA;EACA,aAAA;EACA,wBAAA;EACA,UAAA;EACA,cAAA;ACJR;ADtEA;EA8EQ,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,yBAAA;EACA,cAAA;EACA,6BAAA;EACA,UAAA;ACLR;AACA,mCAAmC","sourcesContent":["@import url('../../../less/variables.less');\n\n.Page {\n    display: flex;\n    flex-flow: column nowrap;\n    position: relative;\n    background-color: @white;\n    border-radius: @radius-sm;\n    box-shadow: @box-shadow-md;\n    margin-top: 20px;\n    margin-right: 15px;\n    margin-left: 15px;\n    overflow-y: auto;\n    \n    @media (min-width: 768px) and (min-height: 576px) {\n        height: calc(100vh - 100px);\n    }\n\n    .PageContent {\n        width: 100%;\n        max-width: 1200px;\n        margin: 0 auto;\n    }\n\n    .PageRow {\n        display: flex;\n        flex-flow: row nowrap;\n        gap: @element-margin;\n\n        @media (max-width: 767px) {\n            flex-flow: column nowrap;\n        }\n\n        .PageCol {\n            flex: 1;\n        }\n    }\n\n    .PageHeader {\n        display: flex;\n        flex-flow: row nowrap;\n        align-items: center;\n        justify-content: space-between;\n        gap: @element-margin;\n        padding: 0.5em @element-margin;\n        background-color: @white;\n    }\n\n    .PageHeader,\n    .PageFooter {\n        &Left,\n        &Center,\n        &Right {\n            flex: 1;\n            display: flex;\n            align-items: center;\n        }\n\n        &Left {\n            justify-content: flex-start;\n        }\n\n        &Center {\n            justify-content: center;\n        }\n\n        &Right {\n            justify-content: flex-end;\n        }\n    }\n\n    .PageMain {\n        flex: 1;\n        display: flex;\n        flex-flow: column nowrap;\n        gap: 0.5em;\n        padding: @element-margin;\n    }\n\n    .PageFooter {\n        position: sticky;\n        inset: auto 0 0 0;\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        gap: @element-margin;\n        background-color: @white;\n        padding: @element-margin;\n        border-top: 1px solid @separator-color;\n        z-index: 1;\n    }\n}",".Page {\n  display: flex;\n  flex-flow: column nowrap;\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 6px;\n  box-shadow: 0 4px 8px -2px rgba(16, 24, 40, 0.1), 0 2px 4px -2px rgba(16, 24, 40, 0.06);\n  margin-top: 20px;\n  margin-right: 15px;\n  margin-left: 15px;\n  overflow-y: auto;\n}\n@media (min-width: 768px) and (min-height: 576px) {\n  .Page {\n    height: calc(100vh - 100px);\n  }\n}\n.Page .PageContent {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n.Page .PageRow {\n  display: flex;\n  flex-flow: row nowrap;\n  gap: 1.5em;\n}\n@media (max-width: 767px) {\n  .Page .PageRow {\n    flex-flow: column nowrap;\n  }\n}\n.Page .PageRow .PageCol {\n  flex: 1;\n}\n.Page .PageHeader {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5em;\n  padding: 0.5em 1.5em;\n  background-color: #ffffff;\n}\n.Page .PageHeaderLeft,\n.Page .PageFooterLeft,\n.Page .PageHeaderCenter,\n.Page .PageFooterCenter,\n.Page .PageHeaderRight,\n.Page .PageFooterRight {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n.Page .PageHeaderLeft,\n.Page .PageFooterLeft {\n  justify-content: flex-start;\n}\n.Page .PageHeaderCenter,\n.Page .PageFooterCenter {\n  justify-content: center;\n}\n.Page .PageHeaderRight,\n.Page .PageFooterRight {\n  justify-content: flex-end;\n}\n.Page .PageMain {\n  flex: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  gap: 0.5em;\n  padding: 1.5em;\n}\n.Page .PageFooter {\n  position: sticky;\n  inset: auto 0 0 0;\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  gap: 1.5em;\n  background-color: #ffffff;\n  padding: 1.5em;\n  border-top: 1px solid #E9EAEB;\n  z-index: 1;\n}\n/*# sourceMappingURL=Page.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
